import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,[_c('app-toolbar'),_c(VMain,{staticClass:"synthesis-brand-dark-blue"},[_c(VContainer,{staticClass:"pa-0 pa-sm-3",attrs:{"fluid":""}},[_c(VRow,{attrs:{"dense":""}},[_c(VCol,{attrs:{"cols":"12"}},[_vm._t("default")],2)],1)],1),_c('contact-dialog',{attrs:{"visible":_vm.contactDialogVisible},on:{"update:visible":function($event){_vm.contactDialogVisible=$event},"dialog:save:success":_vm.onContactSuccess}})],1),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }